<div class="not-authorized-wrapper" fxLayout="column" fxLayoutAlign="center center">

  <h1>403 Forbidden</h1>
  <p>Sorry but you don't have acces to this page</p>
  <a [routerLink]="'/'">Go back to home</a>

</div>
